module.exports = __webpack_public_path__ + "assets/img/36_572_big.19d1e0f6.jpg";